export interface MedicaoField<T> {
  medicao: T
  dataMedicao: string
}

export interface MedicoesAcompanhamentoPreNatal {
  alturaUterina?: MedicaoField<string>
  peso?: MedicaoField<number | string>
  batimentoCardiacoFetal?: MedicaoField<string>
  edema?: MedicaoField<string>
  movimentacaoFetal?: MedicaoField<boolean>
  pressaoArterial?: MedicaoField<string>
}

export const MEDICOES_ACOMPANHAMENTO_PRE_NATAL: Array<keyof MedicoesAcompanhamentoPreNatal> = [
  'alturaUterina',
  'peso',
  'batimentoCardiacoFetal',
  'edema',
  'movimentacaoFetal',
  'pressaoArterial',
]
